import React from 'react';
import PropTypes from 'prop-types';
import RecommendedTargetAmountChart from '../../RecommendedTargetAmountChart/RecommendedTargetAmountChartContainer';

const HomePurchaseGoalChartView = props => {
  const { initialChartData, goalId, clientId, fpId, isCurrentPlan, responseData, title } = props;
  return (
    <>
      <h4>{title}</h4>
      <RecommendedTargetAmountChart
        noContainer
        hasLegend
        title={isCurrentPlan ? 'Savings Schedule' : 'Recommended Savings Schedule'}
        goalId={goalId}
        data={initialChartData ? { GoalCharts: [initialChartData] } : null}
        responseData={responseData}
        clientId={clientId}
        fpId={fpId}
      />
    </>
  );
};

HomePurchaseGoalChartView.propTypes = {
  initialChartData: PropTypes.shape({}).isRequired,
  goalId: PropTypes.string.isRequired,
  responseData: PropTypes.shape({}).isRequired,
  clientId: PropTypes.string.isRequired,
  fpId: PropTypes.string.isRequired,
  isCurrentPlan: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};

export default HomePurchaseGoalChartView;
